import { Directive, ElementRef, Output, EventEmitter, OnInit } from '@angular/core';

@Directive({
  selector: '[appAutoradioVisibility]'
})
export class AutoradioVisibilityDirective implements OnInit {
  @Output() autoradioVisible = new EventEmitter<void>();
  private isVisible = false;

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    const options = {
      rootMargin: '0px',
      threshold: 0.5
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.isVisible) {
          this.isVisible = true;
          this.autoradioVisible.emit();
        }
      });
    }, options);

    observer.observe(this.elementRef.nativeElement);
  }
}
